export const BRAND = {
  logoFull: "https://customer-assets.emergentagent.com/job_asia-wholesale-hub/artifacts/rqrcutop_asiacommerce-hub-logo.png",
  logoIcon: "https://customer-assets.emergentagent.com/job_asia-wholesale-hub/artifacts/o1chxj3h_60f312044a0fb2c92181dfe8461660fc.webp",
  mascot: "https://customer-assets.emergentagent.com/job_asia-wholesale-hub/artifacts/rmctcgxl_images.png",
  logoTagline: "https://customer-assets.emergentagent.com/job_asia-wholesale-hub/artifacts/j2r35u9v_logo-asiacommerce-Hi-size.png",
};

export const IMAGES = {
  warehouse: "https://images.unsplash.com/photo-1759272548470-d0686d071036?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHx3YXJlaG91c2UlMjBzaGlwcGluZyUyMGNvbnRhaW5lcnxlbnwwfHx8fDE3NzY5MzE2MjZ8MA&ixlib=rb-4.1.0&q=85",
  factory: "https://images.unsplash.com/photo-1716643863806-989dd76ae093?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxjaGluYSUyMGZhY3RvcnklMjB3aG9sZXNhbGUlMjBwcm9kdWN0aW9ufGVufDB8fHx8MTc3NjkzMTY2Nnww&ixlib=rb-4.1.0&q=85",
  trader: "https://images.unsplash.com/photo-1758598306346-d6fe63d82149?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxlLWNvbW1lcmNlJTIwb25saW5lJTIwc2hvcCUyMG1vYmlsZSUyMHBob25lfGVufDB8fHx8MTc3NjkzMTY2Nnww&ixlib=rb-4.1.0&q=85",
  marketingKit: "https://images.pexels.com/photos/7109206/pexels-photo-7109206.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  products: "https://images.pexels.com/photos/9859316/pexels-photo-9859316.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

// Product grid sample cards
export const PRODUCT_CARDS = [
  {
    id: 1,
    name: "Portable Mini Projector",
    nameId: "Mini Projector Portable",
    wholesale: "Rp 185.000",
    retail: "Rp 495.000",
    margin: "+167%",
    img: "https://images.unsplash.com/photo-1626379801357-537572c5da75?auto=format&fit=crop&w=800&q=80",
    tag: "tag1",
  },
  {
    id: 2,
    name: "Smart Kitchen Organizer",
    nameId: "Organizer Dapur Smart",
    wholesale: "Rp 42.000",
    retail: "Rp 149.000",
    margin: "+255%",
    img: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=800&q=80",
    tag: "tag2",
  },
  {
    id: 3,
    name: "Wireless Earbuds Pro",
    nameId: "Earbuds Wireless Pro",
    wholesale: "Rp 78.000",
    retail: "Rp 225.000",
    margin: "+188%",
    img: "https://images.unsplash.com/photo-1590658268037-6bf12165a8df?auto=format&fit=crop&w=800&q=80",
    tag: "tag3",
  },
  {
    id: 4,
    name: "Korean Beauty Set",
    nameId: "Set Beauty Korea",
    wholesale: "Rp 95.000",
    retail: "Rp 289.000",
    margin: "+204%",
    img: "https://images.unsplash.com/photo-1522335789203-aaa1f2cbca80?auto=format&fit=crop&w=800&q=80",
    tag: "tag4",
  },
  {
    id: 5,
    name: "LED Desk Ambient Light",
    nameId: "Lampu Meja LED Ambient",
    wholesale: "Rp 55.000",
    retail: "Rp 179.000",
    margin: "+225%",
    img: "https://images.unsplash.com/photo-1507473885765-e6ed057f782c?auto=format&fit=crop&w=800&q=80",
    tag: "tag3",
  },
  {
    id: 6,
    name: "Premium Silk Pillowcase",
    nameId: "Sarung Bantal Sutra Premium",
    wholesale: "Rp 38.000",
    retail: "Rp 129.000",
    margin: "+239%",
    img: "https://images.unsplash.com/photo-1584100936595-c0654b55a2e2?auto=format&fit=crop&w=800&q=80",
    tag: "tag2",
  },
];
